<template>
  <div :class="item.wrapperClass">
    <component :is="componentVariant" :item="item"></component>
  </div>
</template>
<script>
import Row from "./row.vue";
import Performance from "./performance.vue";
export default {
  props: {
    item: Object,
  },
  components: {
    Row,
    Performance,
  },
  computed: {
    values() {
      if (this.item.values) {
        return this.item.values;
      } else {
        return [{ value: this.item.value, to: this.item.to || null }];
      }
    },
    componentVariant() {
      return this.item.variant || "row";
    },
  },
};
</script>